import { Injectable, inject } from '@angular/core';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';
import type { IndexWidget, Widget } from 'instantsearch.js';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InstantSearchService {
  private auth = inject(AuthService);

  public searchInitialized$ = new BehaviorSubject<boolean>(false);
  public instantSearchInstance: InstantSearch;
  public searchClient: any;

  initConfig(force: boolean = false) {
    if (this.searchInitialized$.value === true && !force) {
      return;
    }
    this.searchInitialized$.next(false);
    this.auth.searchKey$.subscribe(searchKey => {
      const searchClient = algoliasearch(
        environment.search.appId,
        searchKey
      );
      this.searchClient = searchClient;
      this.instantSearchInstance = new InstantSearch({
        searchClient,
        future: { preserveSharedStateOnUnmount: true },
      });
      this.instantSearchInstance.start();
      this.searchInitialized$.next(true);
    });
  }

  start() {
    this.instantSearchInstance.start();
  }

  addWidgets(widgets: Array<IndexWidget | Widget>) {
    this.instantSearchInstance?.addWidgets(widgets);
  }

  removeWidgets(widgets: Array<IndexWidget | Widget>) {
    this.instantSearchInstance?.removeWidgets(widgets);
  }

  refresh() {
    this.instantSearchInstance?.refresh();
  }
}
